
function randomStr(n) { // 生成n位长度的字符串
  var str = "abcdefghijklmnopqrstuvwxyz0123456789"; // 可以作为常量放到random外面
  var result = "";
  for(let i = 0; i < n; i++) {
    result += str[parseInt(Math.random() * str.length)];
  }
  return result;
}


function deepCopy(source){
  if (typeof source != "object") {
     return source;
  }
  if (source == null) {
      return source;
  }
  var newObj = source.constructor === Array ? [] : {};  //开辟一块新的内存空间
  for (var i in source) {
       newObj[i] = deepCopy(source[i]);
  }
  return newObj;
}


export default {
  randomStr: randomStr,
  deepCopy: deepCopy
};

